import { gql, useMutation } from '@apollo/client'
import { useAlert, useNotification } from '@btime/react-messager'
import { useTranslation } from 'react-i18next'

import { generalClient } from '../../../../../../utils/apollo/api'

const MUTATION = gql`
  mutation RemoveConfig($id: Int) {
    removeConfig(id: $id)
  }
`

export const useRemoveDocumentHeader = () => {
  const notify = useNotification()
  const [request, state] = useMutation(MUTATION, { refetchQueries: ['Config', 'Configs'], client: generalClient })
  const modal = useAlert()
  const { t } = useTranslation('common')

  const handleRequest = id => {
    if (!modal.confirm({ title: t('confirmRemove') })) return false

    return request({ variables: { id } }).then(resp => {
      if (!resp.errors) {
        notify.success({ title: t('removeSuccess') })
      } else {
        notify.error({ title: t('errors.remove') })
      }
    })
  }

  return [handleRequest, state]
}
